import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import Message from "assets/scripts/components/common/Message/Message";
import { ERRORS } from "assets/scripts/constants/FormMessages";
import createRef from "assets/scripts/utils/createRef";
export const ERROR_FOCUS_ATTRIBUTE = "data-error-focus-23412d43";
const DEFAULT_FORM_STATE = {
    version: 0,
    failedSubmit: null,
    isBusy: false,
    disabled: false
};
const { Consumer, Provider } = React.createContext(DEFAULT_FORM_STATE);
export const FormSubscriber = ({ children }) => (<Consumer>
		{children}
	</Consumer>);
export const RequiredMessage = ({ className }) => (<div className={classNames("vr vr_x3", className)}>
		<div className="note">
			<FormattedMessage id="forms.requiredMessage" defaultMessage="Fields marked with * are required."/>
		</div>
	</div>);
export const FormProvider = (props) => {
    const { children, ...otherProps } = props;
    const formState = {
        ...DEFAULT_FORM_STATE,
        ...otherProps
    };
    return (<Provider value={formState}>
			{children}
		</Provider>);
};
class Form extends Component {
    constructor(props, context) {
        super(props, context);
        this._containerRef = createRef();
        this._formRef = createRef();
        this._renderSubmitButton = () => {
            const disabled = this.props.isBusy || this.props.submitDisabled;
            return (<button type="submit" className={classNames("btn mix-btn_fixedWidth btn-action", {
                btn_isDisabled: disabled
            })} disabled={disabled}>
				<Message value={this.props.submitLabel}/>
			</button>);
        };
        this.state = {
            version: 0,
            failedSubmit: null
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state } = this;
        return (<FormProvider {...state} isBusy={props.isBusy} disabled={props.disabled}>
				<form ref={this._formRef} onSubmit={this._handleSubmit} className={classNames("tCombForm", props.className)} method="POST" action="" noValidate data-test={props["data-test"]} autoComplete={props.autoComplete}>
					{!props.hideRequiredMessage && <RequiredMessage />}
					<div className="formGroupContainer">
						<div ref={this._containerRef} className="formGroupContainer-fields">
							{state.failedSubmit != null && (<div className="alert alert-danger" role="alert">
									{ERRORS.GLOBAL}
								</div>)}

							{props.error != null && (<div className="alert alert-danger" role="alert">
									<Message value={props.error}/>
								</div>)}

							{props.children}
						</div>
						<div className="formGroupContainer-btn">
							{props.renderButtons == null ? this._renderSubmitButton() : (props.renderButtons({
            renderSubmitButton: this._renderSubmitButton
        }))}
						</div>
					</div>
				</form>
			</FormProvider>);
    }
    _handleSubmit(event) {
        event.preventDefault();
        if (this.props.onPreSubmit != null) {
            this.props.onPreSubmit();
        }
        if (this.props.isValid) {
            this.setState(prevState => ({
                failedSubmit: null,
                version: prevState.version + 1
            }));
            this.props.onSubmit();
        }
        else {
            this.setState(prevState => ({
                failedSubmit: prevState.failedSubmit == null ? 0 : prevState.failedSubmit + 1
            }), () => this._focusFirstError());
        }
    }
    _focusFirstError() {
        if (this._containerRef.value != null) {
            const errorElement = this._containerRef.value.querySelector(`[${ERROR_FOCUS_ATTRIBUTE}]`);
            if (errorElement != null && errorElement !== document.activeElement) {
                errorElement.focus();
            }
        }
    }
    submit() {
        if (this._formRef.value == null) {
            throw new Error("Unexpected state");
        }
        this._formRef.value.submit();
    }
}
export default Form;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/Form/Form.tsx